
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAlert = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.964 3.398a2 2 0 0 1 .788.788l7.618 13.85A2 2 0 0 1 19.617 21H4.383a2 2 0 0 1-1.753-2.964l7.618-13.85a2 2 0 0 1 2.716-.788ZM12 15.35a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm.024-7.5c-.69 0-1.25.56-1.25 1.25v3.65a1.25 1.25 0 1 0 2.5 0V9.1c0-.69-.56-1.25-1.25-1.25Z",
  fill: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.9639 3.39766C13.2962 3.58044 13.5697 3.85393 13.7525 4.18625L21.3699 18.0362C21.9022 19.004 21.5492 20.2201 20.5813 20.7524C20.286 20.9149 19.9545 21 19.6175 21H4.38257C3.278 21 2.38257 20.1046 2.38257 19C2.38257 18.663 2.46773 18.3315 2.63014 18.0362L10.2476 4.18625C10.7799 3.21841 11.996 2.86535 12.9639 3.39766ZM12 15.3503C11.1716 15.3503 10.5 16.0219 10.5 16.8503C10.5 17.6787 11.1716 18.3503 12 18.3503C12.8285 18.3503 13.5 17.6787 13.5 16.8503C13.5 16.0219 12.8285 15.3503 12 15.3503ZM12.0236 7.85031C11.3332 7.85031 10.7736 8.40995 10.7736 9.10031V12.75C10.7736 13.4404 11.3332 14 12.0236 14C12.7139 14 13.2736 13.4404 13.2736 12.75V9.10031C13.2736 8.40995 12.7139 7.85031 12.0236 7.85031Z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/alert.fbb3d6cf032d88a1922d2a3636d2a7fe.svg"),
        {
          React: SvgAlert,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      